import React, { useState, useEffect, useRef } from "react";
import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import SideMenu from "../../src/Pages/SideMenu";
import Header from "../../src/Pages/Header";
import Footer from "../../src/Pages/Footer";
import Logout from "../../src/Pages/Logout";
import axios from "axios";
import Accordion from "react-bootstrap/Accordion";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { equipmentMonitorAssignedList, getFileByPath } from "../Utilities/URLCONSTANTS";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import Loader_Bulk from "../Utilities/Loader_Bulk";
import moment from "moment";
import { customstyles } from "../Utilities/utils";
import Select from "react-select";

const RepairMaintenace = (category, index) => {
  const [data, setData] = useState([]);
  const [loaderImage, setLoaderImage] = useState(
    require("../images/rmloader.gif")
  );
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [remark, setRemark] = useState();
  const [showPopup, setShowPopup] = useState(false);
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const [estDate, setEstDate] = useState();
  const [corePermit, setCorePermit] = useState("");
  const [assignWork, setAssignWork] = useState();
  const [isBoxVisible, setBoxVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const handleRadioChange = (value) => {
    setCorePermit(value);
  };
  const handleFilter = (searchTerm) => {
    setSearchTerm(searchTerm);
    if (data != null && data != undefined) {
      const filteredResults = data.filter(
        (item) =>
          item.date.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.createdByEmpName
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item.equipment.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.startDate.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.site
            .toString()
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item.subSite.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filteredResults);
    }
    console.log("fdsafaGFH", filteredData);
  };

  const handleAprove = () => {
    setBoxVisible(true);
  };

  const closeBox = () => {
    setBoxVisible(false);
  };
  const handleModalOpen = () => {
    setShowModal(true);
  };
  const handleModalClose = () => {
    setShowModal(false);

    //  window.location.reload();
  };
  // const handleImageClick = (imageUrl) => {
  //   window.open(imageUrl, "_blank");
  // };

  const handleImageClick = async (imageUrl) => {
    // Open tab immediately (avoids popup blocker)
    const newWindow = window.open("", "_blank");

    try {
      const postData = {
        url: imageUrl,
      };

      const response = await axios.post(getFileByPath, postData);

      console.log("Image Response:", response.data);

      const data = response.data.response || response.data.data || response.data;

      if (!data?.base64) {
        throw new Error("Base64 image not found.");
      }

      const { base64, contentType } = data;

      const dataUrl = `data:${contentType};base64,${base64}`;

      if (newWindow) {
        newWindow.document.open();
        newWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>Profile Image</title>
            <style>
              html, body {
                margin: 0;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #f5f5f5;
              }
              img {
                max-width: 90%;
                max-height: 90%;
                object-fit: contain;
              }
            </style>
          </head>
          <body>
            <img src="${dataUrl}" alt="Profile Image" />
          </body>
        </html>
      `);
        newWindow.document.close();
      }
    } catch (err) {
      console.error("Image Error:", err);

      if (newWindow) {
        newWindow.close();
      }
    }
  };


  const handleClose = () => {
    setShowPopup(false);
    setShowModal(false);
    setShowWarningPopup(false);
    window.location.reload();
  };
  const handleDateChange = (e) => {
    setEstDate(e.target.value);
  };
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  useEffect(() => {
    if (data != null && data != undefined) {
      //  const totalItems = data.length;
      setFilteredData(data);
      setTotalItems(data.length);
    }
  }, [data]);

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  console.log(currentItems);
  const handleItemsPerPageChange = (e) => {
    const selectedValue = parseInt(e.target.value);
    setItemsPerPage(selectedValue);
    setCurrentPage(1); // Reset to the first page when changing items per page.
  };

  // const totalItems = data.length;

  const pageNumbers = [];
  for (
    let i = Math.max(2, currentPage - 1);
    i <= Math.min(Math.ceil(totalItems / itemsPerPage) - 1, currentPage + 1);
    i++
  ) {
    pageNumbers.push(i);
  }

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  const fetchData = async () => {
    const getApi = equipmentMonitorAssignedList;
    const headers = await GetApiHeaders();
    try {
      setIsLoading(true);
      const response = await axios.post(getApi, {}, { headers });
      console.log("res:", response);
      const equipmentMonitoring =
        response.data?.response?.equipmentMonitoring || [];
      setData(equipmentMonitoring);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
    }
  };


  useEffect(() => {
    fetchData();
  }, []);
  const handleClear = () => {
    setSearchTerm("");
  };
  return (
    <body id="page-top">
      <div id="wrapper">
        <SideMenu />

        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />

            <div>
              <div className="container-fluid">
                <div className="card border-0">
                  <div className="card-body pt-0 pl-1">
                    <h5 className="Roles_text">Preventive Maintenance </h5>
                    <div className="d-flex justify-content-between"></div>
                    <div className="mcrc_hrline">
                      <div className="card-body " style={{ padding: "10px" }}>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{}}
                        >
                          <div className="d-flex align-items-center">
                            <label className="mr-1">Show </label>
                            <Select
                              options={[
                                { value: 10, label: '10' },
                                { value: 20, label: '20' },
                                { value: 50, label: '50' },
                              ]}
                              value={{
                                value: itemsPerPage,
                                label: String(itemsPerPage),
                              }}
                              onChange={(selected) => {
                                setItemsPerPage(selected.value);
                                setCurrentPage(1);
                              }}
                              isSearchable={false}
                              styles={customstyles}
                            />

                            &nbsp;
                            <label> Entries</label>
                          </div>
                          <div
                            className="d-flex align-items-center"
                            style={{ marginRight: "-10px" }}
                          >
                          </div>
                        </div>
                        <div></div>
                      </div>
                    </div>
                    <div>
                      <div className="card data_tableCard">
                        <div className="card-body">
                          <Table className=" Content_data_table">
                            <Thead>
                              <Tr>
                                <Th className="pl-1 preventive-header">S.No</Th>
                                <Th className="text-center p-2  preventive-header">
                                  Preventive Maintenance
                                </Th>
                              </Tr>
                            </Thead>
                            <Tbody>

                              {data.map((item, index) => {
                                var newDateFormat = moment(
                                  item.workCreatedDate
                                ).format("DD-MMM-YYYY hh:mm:ss A");
                                var scheduleDate = moment(item.date).format(
                                  "DD-MMM-YYYY "
                                );
                                var startDate = moment(item.startDate).format(
                                  "DD-MMM-YYYY "
                                );
                                var endDate = moment(item.endDate).format(
                                  "DD-MMM-YYYY "
                                );
                                return (
                                  <Tr key={index}>
                                    <Td className="pl-1">{index + 1}</Td>
                                    <Td>
                                      <Accordion
                                        defaultActiveKey="0"
                                        className="acc mt-3 mb-2"
                                        id="dns"
                                      >
                                        <Accordion.Item eventKey="1">
                                          <Accordion.Header>
                                            <div
                                              style={{
                                                fontSize: 14,
                                                width: "100%",
                                              }}
                                              className="ProductNameHeaderEq d-flex"
                                            >
                                              <span
                                                className=""
                                                style={{ width: "17%" }}
                                              >
                                                <b className="">
                                                  {" "}
                                                  Request ID &nbsp;&nbsp;
                                                  :&nbsp;{" "}
                                                </b>{" "}
                                                <span>
                                                  {" "}
                                                  {item.serverRecordId}
                                                </span>
                                              </span>
                                              <span
                                                className=""
                                                style={{ width: "33%" }}
                                              >
                                                <b className="">
                                                  {" "}
                                                  Work Created Date &nbsp;&nbsp;
                                                  :&nbsp;{" "}
                                                </b>{" "}
                                                <span> {newDateFormat}</span>
                                              </span>
                                              <span
                                                // style={{ width: "30%" }}
                                                style={{
                                                  width: "30%",
                                                  whiteSpace: "normal",
                                                  overflowWrap: "break-word",
                                                  wordBreak: "break-word",
                                                  // paddingRight: "10px",
                                                }}
                                              >
                                                <b className="quantty">
                                                  {" "}
                                                  Created By{" "}
                                                  <span
                                                    style={{ marginLeft: 10 }}
                                                  >
                                                    :&nbsp;{" "}
                                                  </span>
                                                </b>{" "}
                                                {/* <span>
                                                  {" "}
                                                  {item.createdByEmpName}{" "}
                                                </span> */}
                                                <span>
                                                  {item.createdByEmpName
                                                    ?.toLowerCase()
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())}{" "}
                                                </span>
                                              </span>
                                              <span
                                                className="  "
                                                style={{ width: "18%" }}
                                              >
                                                <b> Status &nbsp;&nbsp;: </b>
                                                &nbsp;
                                                <span>
                                                  {" "}
                                                  {item.status === "Open" ? (
                                                    <span
                                                      style={{
                                                        color: "#FF0000",
                                                        fontWeight: 600,
                                                      }}
                                                    >
                                                      Open
                                                    </span>
                                                  ) : item.status ===
                                                    "Close" ? (
                                                    <span
                                                      style={{
                                                        color: "#008000",
                                                        fontWeight: 600,
                                                      }}
                                                    >
                                                      Close
                                                    </span>
                                                  ) : item.status}{" "}
                                                </span>{" "}
                                                &nbsp; &nbsp;
                                              </span>
                                            </div>
                                          </Accordion.Header>

                                          <Accordion.Body>
                                            <div style={{ fontSize: 14, width: "100%", }}
                                              className="ProductNameForRandM d-flex mt-3"   >
                                              <span style={{ width: '33.4%' }}>
                                                <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                  Created by Mobile No
                                                </span>
                                                <span >  :&nbsp;
                                                </span>
                                                <span style={{ width: '55%', display: 'inline-block' }}>{item.createdByEmpMobileNumber}</span>
                                              </span>
                                              <span style={{ width: '33.4%' }}>
                                                <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                  Schedule For
                                                </span>
                                                <span >  :&nbsp;
                                                </span>
                                                <span style={{ width: '55%', display: 'inline-block' }}>{scheduleDate}</span>
                                              </span>

                                              {item.hasOwnProperty("site") &&
                                                item.site != "" &&
                                                item.site != 0 && (
                                                  <span style={{ width: '33.4%' }}>
                                                    <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                      Site
                                                    </span>
                                                    <span >  :&nbsp;
                                                    </span>
                                                    <span style={{ width: '55%', display: 'inline-block' }}>{item.site}</span>
                                                  </span>

                                                )}


                                            </div>
                                            <div style={{ fontSize: 14, width: "100%", }}
                                              className="ProductNameForRandM d-flex mt-3"   >
                                              {item.hasOwnProperty("subSite") &&
                                                item.subSite != "" &&
                                                item.subSite != 0 && (
                                                  <span style={{ width: '33.4%' }}>
                                                    <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                      Sub Site
                                                    </span>
                                                    <span >  :&nbsp;
                                                    </span>
                                                    <span style={{ width: '55%', display: 'inline-block' }}>{item.subSite}</span>
                                                  </span>

                                                )}


                                              {item.hasOwnProperty(
                                                "location"
                                              ) &&
                                                item.location != "" &&
                                                item.location != 0 &&
                                                item.locationId != "" &&
                                                item.locationId != 0 && (
                                                  <span style={{ width: '33.4%' }}>
                                                    <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                      Location
                                                    </span>
                                                    <span >  :&nbsp;
                                                    </span>
                                                    <span style={{ width: '55%', display: 'inline-block' }}>{item.location}</span>
                                                  </span>
                                                )}
                                              {item.hasOwnProperty(
                                                "subLocation"
                                              ) &&
                                                item.subLocation != "" &&
                                                item.subLocation != 0 &&
                                                item.subLocationId != 0 &&
                                                item.subLocationId != 0 && (
                                                  <span style={{ width: '33.4%' }}>
                                                    <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                      Sub Location
                                                    </span>
                                                    <span >  :&nbsp;
                                                    </span>
                                                    <span style={{ width: '55%', display: 'inline-block' }}>{item.subLocation}</span>
                                                  </span>
                                                )}
                                            </div>

                                            <div style={{ fontSize: 14, width: "100%", }}
                                              className="ProductNameForRandM d-flex mt-3"   >
                                              {item.equipment && (
                                                <span style={{ width: '33.4%' }}>
                                                  <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                    Equipment
                                                  </span>
                                                  <span >  :&nbsp;
                                                  </span>
                                                  <span style={{ width: '55%', display: 'inline-block' }}>{item.equipment}</span>
                                                </span>)}

                                              {item.startDate !== "" ? (
                                                <span style={{ width: '33.4%' }}>
                                                  <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                    Start Date
                                                  </span>
                                                  <span >  :&nbsp;
                                                  </span>
                                                  <span style={{ width: '55%', display: 'inline-block' }}>{startDate}</span>
                                                </span>

                                              ) : (
                                                ""
                                              )}

                                              {item.endDate !== "" ? (
                                                <span style={{ width: '33.4%' }}>
                                                  <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                    End Date
                                                  </span>
                                                  <span >  :&nbsp;
                                                  </span>
                                                  <span style={{ width: '55%', display: 'inline-block' }}>{endDate}</span>
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                            {(item.make || item.model || item.serialNumber) && (
                                              <div
                                                style={{ fontSize: 14, width: "100%" }}
                                                className="ProductNameForRandM d-flex mt-3"
                                              >
                                                {item.make && (
                                                  <span style={{ width: '33.4%' }}>
                                                    <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }}>
                                                      Make
                                                    </span>
                                                    <span>:&nbsp;</span>
                                                    <span style={{ width: '55%', display: 'inline-block' }}>{item.make}</span>
                                                  </span>
                                                )}

                                                {item.model && (
                                                  <span style={{ width: '33.4%' }}>
                                                    <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }}>
                                                      Model
                                                    </span>
                                                    <span>:&nbsp;</span>
                                                    <span style={{ width: '55%', display: 'inline-block' }}>{item.model}</span>
                                                  </span>
                                                )}

                                                {item.serialNumber && (
                                                  <span style={{ width: '33.4%' }}>
                                                    <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }}>
                                                      Serial Number
                                                    </span>
                                                    <span>:&nbsp;</span>
                                                    <span style={{ width: '55%', display: 'inline-block' }}>{item.serialNumber}</span>
                                                  </span>
                                                )}
                                              </div>
                                            )}


                                            <div style={{ fontSize: 14, width: "100%", }}
                                              className="ProductNameForRandM d-flex mt-3"   >
                                              {item.technicianShiftName && (
                                                <span style={{ width: '33.4%' }}>
                                                  <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                    Assign To Shift
                                                    {/* Technician Role */}
                                                  </span>
                                                  <span >  :&nbsp;
                                                  </span>
                                                  <span style={{ width: '55%', display: 'inline-block' }}>{item.technicianShiftName}</span>
                                                </span>)}

                                              {item.abnormality !== "" ? (
                                                <span style={{ width: '33.4%' }}>
                                                  <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                    Equipment Condition
                                                  </span>
                                                  <span >  :&nbsp;
                                                  </span>
                                                  <span style={{ width: '55%', display: 'inline-block' }}>{item.abnormality}</span>
                                                </span>) : ("")}

                                              {item.equipmentDescription && (
                                                <span style={{ width: '33.4%' }}>
                                                  <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                    Equipment Description
                                                  </span>
                                                  <span >  :&nbsp;
                                                  </span>
                                                  <span
                                                    // style={{
                                                    //    width: '55%', display: 'inline-block' }}
                                                    style={{
                                                      width: "55%",
                                                      display: "inline-flex",
                                                      whiteSpace: "normal",
                                                      overflowWrap: "anywhere",
                                                      wordBreak: "break-word",
                                                    }}
                                                  >
                                                    {item.equipmentDescription}</span>
                                                </span>)}
                                            </div>

                                            <div style={{ fontSize: 14, width: "100%", }}
                                              className="ProductNameForRandM d-flex mt-3"   >
                                              {item.equipmentCategory && (
                                                <span style={{ width: '33.4%' }}>
                                                  <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                    Equipment Category
                                                  </span>
                                                  <span >  :&nbsp;
                                                  </span>
                                                  <span style={{ width: '55%', display: 'inline-block' }}>{item.equipmentCategory}</span>
                                                </span>)}

                                              {item.remarks !== "" ? (
                                                <span style={{ width: '33.4%' }}>
                                                  <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                    Remarks
                                                  </span>
                                                  <span >  :&nbsp;
                                                  </span>
                                                  <span style={{ width: '55%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.remarks}</span>
                                                </span>) : (
                                                ""
                                              )}

                                              {item.status === "Close" ? (
                                                <span style={{ width: '33.4%' }}>
                                                  <span style={{ width: '43%', display: 'inline-block', fontWeight: 600 }} >
                                                    Images
                                                  </span>
                                                  <span >  :&nbsp;
                                                  </span>
                                                  <span style={{ width: '58%' }}> {item.uploadCheckList.map(
                                                    (imageUrl, imgIndex) => (
                                                      <span key={imgIndex}
                                                        style={{
                                                          marginRight: "10px",
                                                          display:
                                                            "inline-block",
                                                          border: "1px solid",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            width: "60%",
                                                          }}
                                                        >
                                                          <img
                                                            key={imgIndex}
                                                            src={imageUrl}
                                                            alt={`Image ${imgIndex}`}
                                                            style={{
                                                              width: "30px",
                                                              height: "40px",
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                              handleImageClick(
                                                                imageUrl
                                                              )
                                                            }
                                                          />
                                                        </span>
                                                      </span>
                                                    )
                                                  )}</span>
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                            <div
                                              style={{ fontSize: 14 }}
                                              className="ProductNameForRandM d-grid"
                                            >
                                            </div>
                                          </Accordion.Body>
                                        </Accordion.Item>
                                      </Accordion>
                                    </Td>
                                  </Tr>
                                );
                              })}
                            </Tbody>
                          </Table>
                        </div>

                        {/* Pagination */}
                        {/* <Pagination
                          currentPage={currentPage}
                          totalItems={sortedData.length}
                          itemsPerPage={itemsPerPage}
                          currentItems={currentItems}
                          onPageChange={handlePageClick}
                        /> */}
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
                {isLoading && (
                  <Loader_Bulk
                    loading={isLoading}
                    message={"Fetching Data. Please Wait..!"}
                    loderimage={loaderImage}
                  />
                )}
              </div>
            </div>
          </div>

          <Footer />
          {/* ... End of Footer...  */}
        </div>
      </div>
      {/*  <!-- End of Page Wrapper -->

                    <!-- Scroll to Top Button--> */}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>

      {/*  <!-- Logout Modal--> */}
      <Logout />
    </body >
  );
};

export default RepairMaintenace;
